export const offersCss = `
<style>/*! CSS Used from: Embedded */
*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}
h3,p,ul{margin:0;padding:0;list-style-type:none;font-weight:400;}
a{text-decoration:none;}
.pull-left{float:left;}
.clearfix:after,.clearfix:before{content:" ";display:table;}
.clearfix:after{clear:both;}
.append_bottom5{margin-bottom:5px;}
.append_bottom10{margin-bottom:10px;}
.font14{font-size:14px;}
h3{font-size:20px;}
.content_blocks{color:#4a4a4a;margin-bottom:40px;}
.content_blocks h3{margin-bottom:20px;color:#000;font-family:Lato-Bold,Arial,Helvetica,sans-serif;}
.fli-sectionbox{font-size:14px;line-height:21px;border:1px solid #d8eaff;border-radius:10px;margin-bottom:20px;background-color:#fff;padding:20px;}
.padd0{padding:0;}
.fli-sectionbox p:last-child{margin-bottom:0;}
.rowBlock{border-bottom:solid 1px #e8e8e8;padding:15px 20px;}
@media screen and (max-device-width:480px) and (orientation:portrait){
    .content_blocks{margin-bottom:25px;}
    .content_blocks h3{margin-bottom:10px;}
}
p{margin-bottom:0;}
a:focus,a:hover{text-decoration:none;}
ul{margin:0;padding:0;list-style-type:none;}
.clearfix:after,.clearfix:before{content:" ";display:table;}
.clearfix:after{clear:both;}
a:focus{outline:0;outline-offset:-2px;}
/*! CSS Used from: Embedded */
.LatoRegular{font-family:Lato-Regular,Arial,Helvetica,sans-serif;}
/*! CSS Used from: Embedded */
.col-lg-3,.col-md-12,.col-sm-12,.col-xs-12{position:relative;min-height:1px;padding-right:10px;padding-left:10px;}
.col-xs-12{float:left;}
.col-xs-12{width:100%;}
@media (min-width:768px){
    .col-sm-12{float:left;}
    .col-sm-12{width:100%;}
}
@media (min-width:992px){
    .col-md-12{float:left;}
    .col-md-12{width:100%;}
}
@media (min-width:1200px){
    .col-lg-3{float:left;}
    .col-lg-3{width:25%;}
}
:after,:before{-webkit-tap-highlight-color:transparent;box-sizing:border-box;padding:0;margin:0;-webkit-font-smoothing:antialiased;}
h3,p,ul{margin:0;list-style:none;padding:0;}
a{text-decoration:none;cursor:pointer;}
a:focus,a:hover{text-decoration:none;outline:0;}
.font14{font-size:14px;line-height:14px;}
.font20{font-size:20px;line-height:20px;}
/*! CSS Used from: Embedded */
.springy-scrollspy-content-inner{margin-bottom:20px;}
.paddR0{padding-right:0!important;}
.content_blocks{margin-top:10px;margin-bottom:25px;}
.content_blocks h3{margin-bottom:10px;color:#000;font-family:Lato-Bold,Arial,Helvetica,sans-serif;font-size:20px;}
#bankOfferHook  .filtersHeading{margin-bottom:0px;}
.fli-sectionbox{font-size:14px;line-height:21px;border:1px solid #d8eaff;border-radius:10px;margin-bottom:20px;background-color:#fff;padding:20px;}
.padd0{padding:0!important;}
.rowBlock{border-bottom:solid 1px #e8e8e8;padding:15px 20px;}
.fli-sectionbox p:last-child{margin-bottom:0;}
.fli-intl-offer-banner{background:#fff;-webkit-box-shadow:0 0 6px 0 rgba(0,0,0,.1);box-shadow:0 0 6px 0 rgba(0,0,0,.1);border:1px solid #b8e986;border-radius:10px;text-align:center;}
.fli-intl-offer-banner .top-section{border-radius:2px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;position:relative;padding:26px 30px 9px;}
.fli-intl-offer-banner .horizontal-divide{width:50px;height:2px;border:1px solid hsla(0,0%,100%,.5);display:inline-block;}
.fli-intl-offer-banner .jagged-border{position:absolute;background-position:-11px -35px;width:298px;height:7px;display:inline-block;bottom:-1px;left:0;}
.fli-intl-offer-banner .bottom-section{background:#fff;color:#878787;padding:0 30px 25px;border-radius:10px;}
.discount-coupon .bottom-section{text-align:left;padding:28px 25px 0 16px;font-family:Lato-Regular,Arial,Helvetica,sans-serif;}
.append_bottom10{margin-bottom:10px;}
label.radio{cursor:pointer;}
.radio{position:relative;margin:0;}
label{font-weight:400!important;}
.discount-coupon .disc-code{border:1px dashed #7ed321;background:#eeffdc;color:#417505;font-size:16px;padding:6px 11px;max-width:170px;}
.copy-code{border:1px solid #ddd;padding:7px 10px;font-size:14px;margin:0 0 2px -4px;border-left:none;color:#0055b7;cursor:pointer;}
.discount-coupon .disc-info{padding-bottom:16px;margin-bottom:18px;border-bottom:1px solid hsla(0,0%,80%,.5);}
.bottom-section .disc-info:last-child{border:none;margin:0;}
.append_bottom5{margin-bottom:5px;}
.airline-right-container{padding-left:0!important;}
.rowBlock .lowest_fare_wrap {
    font-style: italic;
    font-weight: bold;
    color: #444;
    font-size: 15px;
}
</style>
`;
